module.exports = __webpack_public_path__ + "static/media/merrill-logo.750604d7.png";